<template>
  <!-- 问诊状态 -->
  <div class="ask-status">
    <span>{{ onStatus(status).label }}</span>
    <span v-if="onStatus(status).desc">
      <span>(</span>
      <span style="color: #f54739">{{ onStatus(status).desc }}</span>
      <span>)</span>
    </span>
    <template v-if="status === 10 && askNo">
      <template v-if="starTime">
        <span>(</span>
        <TimeCountdown :start-time="starTime" @end="$emit('init')" />
        <span>)</span>
      </template>
      <span
        class="link"
        @click="$router.push(`/reservation/pay?askNo=${askNo}`)"
      >
        挂号缴费
      </span>
    </template>
  </div>
</template>
<script>
import TimeCountdown from "@/components/time/countdown/index.vue";
export default {
  name: "co-copy",
  components: {
    TimeCountdown,
  },
  props: {
    status: [String, Number],
    existAddress: [Boolean, String],
    askNo: [String],
    starTime: String,
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  destroyed() {},
  methods: {
    // onStatus(status) {
    //   switch (status) {
    //     case 0:
    //       return {
    //         label: "待受理",
    //       };
    //     case 1:
    //       return {
    //         label: "受理中",
    //       };
    //     case 2:
    //       return {
    //         label: "待支付",
    //       };
    //     case 3:
    //       return {
    //         label: "待发货",
    //         desc: !this.existAddress ? "无收货地址" : "",
    //       };
    //     case 4:
    //       return {
    //         label: "待揽收",
    //       };
    //     case 5:
    //       return {
    //         label: "待签收",
    //       };
    //     case 6:
    //       return {
    //         label: "已完成",
    //       };
    //     case 7:
    //       return {
    //         label: "超时关闭",
    //       };
    //     case 8:
    //       return {
    //         label: "待自取",
    //       };
    //     case 9:
    //       return {
    //         label: "已退货",
    //       };
    //     case 10:
    //       return {
    //         label: "挂号待支付",
    //       };
    //     case 11:
    //       return {
    //         label: "已退款",
    //       };
    //     default:
    //       return {
    //         label: "",
    //       };
    //   }
    // },
    onStatus(status) {
      switch (status) {
        case 0:
          return {
            label: "待问诊",
          };
        case 1:
          return {
            label: "问诊中",
          };
        case 2:
          return {
            label: "已完成",
          };
        case 3:
          return {
            label: "挂号待支付",
          };
        case 4:
          return {
            label: "已退货",
          };
        case 7:
          return {
            label: "已取消",
          };
        case 8:
          return {
            label: "已超时",
          };
        default:
          return {
            label: "",
          };
      }
    },
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
.link {
  margin-left: 10px;
  color: #4187f7;
  cursor: pointer;
}
.co-copy {
  border: 1px solid #e5e5e5;
  border-radius: 50px;
  margin-left: 8px;
  margin-top: -1px;
  padding: 0 8px;
  font-size: 12px;
  display: inline-block;
  cursor: pointer;
  transform: scale(0.9);
  color: #999;
  &:hover {
    opacity: 0.8;
  }
  &.disabled {
    border-color: #999;
    color: #666;
    opacity: 1;
    cursor: default;
  }
  .input {
    position: fixed;
    left: 100%;
    top: -100%;
    height: 1px;
    width: 1px;
    border: none;
    overflow: hidden;
  }
}
</style>
